import { BOTTOM_MODAL_SHADOW } from "components/common/BottomModal/BottomModal";
import { IconsModal } from "../../LeftBar/Buttons/IconsModal/IconsModal";
import { ActiveType } from "../useBottomMenu";
import { Padding } from "./Padding/Padding";

export interface ContentProps {
    activeType: ActiveType | null;
    closePopup: () => void;
}

export const Content = ({ activeType, closePopup }: ContentProps) => {
    return (
        <div
            className="bg-white mb-2 absolute bottom-full left-0 right-0 rounded-xl flex flex-col gap-2"
            onClick={closePopup}
            style={{
                boxShadow: BOTTOM_MODAL_SHADOW,
            }}
        >
            <IconsModal isOpen={activeType === "icon"} close={closePopup} />
            <Padding isOpen={activeType === "padding"} close={closePopup} />
        </div>
    );
};
